import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-460a5267"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon",
  src: "https://static-s.theckb.com/BusinessMarket/SEO/activity-coupon-logo.png",
  alt: ""
}, null, -1))
const _hoisted_2 = { class: "tips" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "coupon" }, "国際送料無料特典", -1))
const _hoisted_4 = {
  key: 1,
  class: "FreeShipping flex-bwn-ter"
}
const _hoisted_5 = { class: "flex-ter" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon",
  src: "https://static-s.theckb.com/BusinessMarket/SEO/activity-coupon-logo.png",
  alt: ""
}, null, -1))
const _hoisted_7 = { class: "tips" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "coupon" }, "国際送料無料特典", -1))
const _hoisted_9 = { class: "flex-ter" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon",
  src: "https://static-s.theckb.com/BusinessMarket/SEO/activity-coupon-logo.png",
  alt: ""
}, null, -1))
const _hoisted_11 = { class: "tips" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "coupon" }, "送料無料特典", -1))
const _hoisted_13 = {
  key: 3,
  class: "CashBack"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-jp.theckb.com/static-asset/activity/cashback_welcome_icon.png",
  alt: ""
}, null, -1))
const _hoisted_15 = { class: "tips" }
const _hoisted_16 = { class: "rate" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" キャッシュバック！ ")
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = ["href"]

import { request } from '@/config/request/interceptors';
import { t } from '@/plugins/i18n'
import { CashbackActivityRespDTO, CouponRespDTO, CustomerActivityRespDTO } from '@/service/market';
import { getJapanTime } from '@/util/common'
import { computed, onMounted, ref } from 'vue';
import dayjs from 'dayjs'
import CountdownTimer from './CountdownTimer.vue'
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import { useRtfix, useUser } from '@/store';
import { formatMoney } from '@/plugins/utils'

export default /*#__PURE__*/_defineComponent({
  props: {
    scene: { type: Number, required: true },
    onFinish: { type: Function, required: false },
    toCreate: { type: Function, required: false }
  },
  setup(__props: any) {

const prop = __props as {
  scene: number // 1商品详情 2 购物车 3 发货引导-2B国际发货单 
  onFinish?: () => void // 可选的回调函数，当倒计时结束时调用
  toCreate?: () => void // 3d 时候去创建
}

const router = useRouter()
const store = useStore()
const couponDeliver = ref<CouponRespDTO>()
const coupon = ref<CustomerActivityRespDTO>()
const isExpiredTip = computed(() => {
  return coupon.value?.couponInfo?.effectEndTime && (dayjs(coupon?.value?.couponInfo?.effectEndTime).diff(dayjs(), 'hour') <= 72)
})

const deliveryTaskNum = ref(-1)
const user = useUser()
const curShop = computed(() => store.state.route.curShop)
const subCustomerId = computed(() => store.getters.user?.customerShopList.find((e: any) => e.customerShopId === curShop.value).customerId)

const cashback = ref<CashbackActivityRespDTO>()

onMounted(async () => {
  const res3 = await request.market.cashback.customerQuery({})
  cashback.value = res3.data
  const res2 = await request.market.activitySceneConfig.customerQuery({})
  if (res2.data?.couponInfo?.usedStatus === 0 && !res2.data?.couponInfo?.endDate) {
    coupon.value = res2.data
  } else {
    if (store.getters['coupon/getCanUseNum'] > 0) {
      const res1 = await request.market.coupon.couponCustomerPage({ pageNum: 1, pageSize: 10, usedStatus: 0, couponType: 3, customerId: subCustomerId.value })
      couponDeliver.value = res1.data?.records?.[0]
      const res = await request.wms.wms.deliveryTaskPage({
        systemSource: user?.systemSource,
        pageNum: 1,
        pageSize: 10,
        customerId: subCustomerId.value
      })
      deliveryTaskNum.value = res.data?.total || 0
    }
  }
})

const goRule = () => {
  location.href = `/sub/activity?id=${coupon.value?.couponInfo?.id}`
}

const goCreate = () => {
  if (prop.scene == 3 && prop.toCreate) {
    prop.toCreate()
    return
  }
  router.push(useRtfix('OrderList'))
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (__props.scene === 1 && coupon.value?.couponInfo?.usedStatus === 0 && !coupon.value?.couponInfo?.endDate)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["FreeShipping", { 'mt-10': _unref(user).systemSource == 2 }])
        }, [
          _hoisted_1,
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createTextVNode("を獲得しました！ " + _toDisplayString(_unref(getJapanTime)(coupon.value?.couponInfo?.effectEndTime, 'YYYY/MM/DD HH:mm')) + " までの初回注文でご利用いただけます。今すぐ商品をチェック！ ", 1),
            (_unref(isExpiredTip))
              ? (_openBlock(), _createBlock(CountdownTimer, {
                  key: 0,
                  "end-time": coupon.value?.couponInfo?.effectEndTime
                }, null, 8, ["end-time"]))
              : _createCommentVNode("", true),
            _createElementVNode("span", {
              class: "ruls",
              onClick: goRule
            }, _toDisplayString('特典詳細 >'))
          ])
        ], 2))
      : (__props.scene === 2 && coupon.value?.couponInfo?.usedStatus === 0 && !coupon.value?.couponInfo?.startDate)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _createTextVNode("を獲得しました！ " + _toDisplayString(_unref(getJapanTime)(coupon.value?.couponInfo?.effectEndTime, 'YYYY/MM/DD HH:mm')) + " までの初回注文でご利用いただけます。今すぐ商品をチェック！ ", 1),
                (_unref(isExpiredTip))
                  ? (_openBlock(), _createBlock(CountdownTimer, {
                      key: 0,
                      "end-time": coupon.value?.couponInfo?.effectEndTime
                    }, null, 8, ["end-time"]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("span", {
              class: "ruls",
              onClick: goRule
            }, _toDisplayString('特典詳細 >'))
          ]))
        : ((__props.scene === 2 || __props.scene === 3) && couponDeliver.value?.id && deliveryTaskNum.value === 0 && _unref(store).getters['coupon/getCanUseNum'])
          ? (_openBlock(), _createElementBlock("div", {
              key: 2,
              class: _normalizeClass([{ 'mt-10': _unref(user).systemSource == 2 }, "FreeShipping flex-bwn-ter"])
            }, [
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _createElementVNode("div", _hoisted_11, [
                  _hoisted_12,
                  _createTextVNode(" の条件を満たしたご注文があります。THE CKBで良品と判断された後、" + _toDisplayString(_unref(getJapanTime)(couponDeliver.value?.endDate, 'YYYY/MM/DD')) + "までに発送手続きを行ってください。発送時に、上限内の送料が自動で割引されます。 ", 1)
                ])
              ]),
              _createElementVNode("span", {
                class: "ruls",
                onClick: goCreate
              }, _toDisplayString('注文ステータスを確認 >'))
            ], 2))
          : ((__props.scene === 2 || __props.scene === 1) && cashback.value?.activityInfo?.id && (+(cashback.value.activityInfo.thresValue ?? 0) - (cashback.value.totalOrderAmount ?? 0) >= 0))
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _hoisted_14,
                _createElementVNode("div", _hoisted_15, [
                  _createTextVNode(" 【" + _toDisplayString(cashback.value?.activityInfo?.sceneType === 8 ? '新規ユーザー限定·お試し応援キャンペーン' : 'リピーター様限定·ご愛顧感謝キャンペーン') + "】累計" + _toDisplayString(_unref(formatMoney)(cashback.value?.activityInfo?.thresValue)) + "元のご注文で ", 1),
                  _createElementVNode("span", _hoisted_16, _toDisplayString(cashback.value?.activityInfo?.cashbackRate) + "%", 1),
                  _hoisted_17,
                  (__props.scene === 2)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_18, "キャンペーン期間：" + _toDisplayString(_unref(getJapanTime)(cashback.value?.activityInfo?.startDate,
            'YYYY/MM/DD')) + "—" + _toDisplayString(_unref(getJapanTime)(cashback.value?.activityInfo?.endDate, 'YYYY/MM/DD')), 1))
                    : _createCommentVNode("", true),
                  (__props.scene === 2)
                    ? (_openBlock(), _createElementBlock("br", _hoisted_19))
                    : _createCommentVNode("", true),
                  _createElementVNode("a", {
                    class: "activity",
                    href: `/hub/cashback?id=${cashback.value?.activityInfo?.id}`,
                    target: "_blank"
                  }, " 詳細を見る>", 8, _hoisted_20)
                ])
              ]))
            : _createCommentVNode("", true)
  ]))
}
}

})